<script lang="ts">
  import type { HTMLInputAttributes } from "svelte/elements";

  import Input from "./input.svelte";
  import InputWrapper from "@/lib/components/input-wrapper/input-wrapper.svelte";

  // https://github.com/sveltejs/eslint-plugin-svelte/issues/348
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface $$Props extends HTMLInputAttributes {
    id?: string;
    value?: string;

    label?: string;
    hint?: string;
    error?: string;
    mask?: string; // optional mask
  }

  export let id = Math.random().toString(36).slice(2);
  export let value = "";

  export let label = "";
  export let hint = "";
  export let error = "";
</script>

<InputWrapper {id} required={$$props.required} {label} {hint} {error}>
  <Input
    {...$$restProps}
    bind:value
    {id}
    on:input
    on:change
    on:focus
    on:blur
    on:value
  />
</InputWrapper>
